<template>
  <div>
    <button class="btn btn-primary" @click="resetConfig">Reset Configuration</button>
    <button class="btn btn-success" @click="saveConfig">Save Configuration</button>
  </div>
</template>

<script setup>
import { defineEmits } from 'vue';

const emits = defineEmits(['reset-config', 'save-config']);

const resetConfig = () => {
  emits('reset-config');
};

const saveConfig = () => {
  emits('save-config');
};
</script>
